import { Routes, mapToResolve, mapToCanActivate } from '@angular/router';
import { LunaClaimValues } from '../models/user-identity.model';
import { HelpLibraryHomeComponent } from "./components/help-library-home/help-library-home.component";
import { HelpLibraryViewerComponent } from "./components/help-library-viewer/help-library-viewer.component";
import { HelpLibraryPreviewComponent } from "./components/help-library-preview/help-library-preview.component";
import { HelpLibraryEditorComponent } from "./components/help-library-editor/help-library-editor.component";
import { HelpLibraryViewResolver } from "./resolvers/help-library-view.resolver";
import { HelpLibraryEditorResolver } from "./resolvers/help-library-editor.resolver";
import { BaseGuardService } from '../auth/guards/base-guard.service';
import { SystemPermissionGuardService } from '../auth/guards/system-permission-guard.service';
import { InternalGuardService } from "../auth/guards/internal-guard.service";

const routeGuards = [BaseGuardService, SystemPermissionGuardService];
const internalGuards = [BaseGuardService, InternalGuardService, SystemPermissionGuardService];

export const HELP_LIBRARY_ROUTES: Routes = [
    {
        path: "view/:categoryId/:id",
        data: { permission: LunaClaimValues.ViewHelpLibrary },
        component: HelpLibraryViewerComponent,
        resolve: {
            help: mapToResolve(HelpLibraryViewResolver)
        },
        children: []
    },
    {
        path: "",
        data: { permission: LunaClaimValues.ViewHelpLibrary },
        component: HelpLibraryHomeComponent,
        canActivate: mapToCanActivate(routeGuards),
        children: [
            {
                path: "create",
                data: { permission: LunaClaimValues.EditHelpLibrary },
                canActivate: mapToCanActivate(internalGuards),
                component: HelpLibraryEditorComponent,
                children: []
            }, 
            {
                path: ":categoryId/:id",
                component: HelpLibraryPreviewComponent,
                children: [
                    {
                        path: "edit",
                        data: { permission: LunaClaimValues.EditHelpLibrary },
						canActivate: mapToCanActivate(internalGuards),
                        component: HelpLibraryEditorComponent,
                        resolve: {
                            help: mapToResolve(HelpLibraryEditorResolver)
                        },
                        children: []
                    },
                    {
                        path: "",
                        data: { permission: LunaClaimValues.ViewHelpLibrary },
						canActivate: mapToCanActivate(routeGuards),
                        component: HelpLibraryViewerComponent,
                        resolve: {
                            help: mapToResolve(HelpLibraryEditorResolver)
                        },
                        children: []
                    }
                ]
            }
        ]
    }
];